import { render, staticRenderFns } from "./featured-features-section.vue?vue&type=template&id=5eda0ec2&scoped=true"
import script from "./featured-features-section.vue?vue&type=script&lang=js"
export * from "./featured-features-section.vue?vue&type=script&lang=js"
import style0 from "./featured-features-section.vue?vue&type=style&index=0&id=5eda0ec2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eda0ec2",
  null
  
)

export default component.exports